import React from "react";
import { useDispatch } from "react-redux";
import {
  deleteOrderRowGoods,
  updateOrderRowGoods,
  updateOrderRowSupplying,
  updateSerialNumber,
  deleteOrderRow,
  postOrderRowGoods,
} from "../../../../../../redux/Actions/orderAction";
import OrderRowComponent from "./order_row";
import { Divs } from "../../../../StyledComponents";
import OrderRowAdd from "./order_row_add";
import { breakdownOfOrderRows } from "../../../../../../helpers/OrdersFunctionsGlobal";

export default function OrderRowsComponent({
  disabled = false,
  order_rows,
  order_id,
  order_shop,
  information_goods_add,
  shipping_address_email,
}) {
  const dispatch = useDispatch();
  return (
    <>
      <Divs>
        <div className="table-responsive bg-silver">
          <div
            className="col-12"
            style={{
              marginBottom: "1rem",
            }}
          >
            <table
              className="table table-sm"
              style={{ marginBottom: "0px!important" }}
            >
              {breakdownOfOrderRows(order_rows).map((item) => (
                <OrderRowComponent
                  disabled={disabled}
                  key={`order_row_${item.id}`}
                  item={item}
                  orderId={order_id}
                  deleteSupply={(id, id_order_row) => {
                    dispatch(deleteOrderRow(order_id, id_order_row, id));
                  }}
                  updateSupplying={(id, id_order_row, new_date) =>
                    dispatch(
                      updateOrderRowSupplying(
                        order_id,
                        id_order_row,
                        id,
                        new_date,
                        shipping_address_email
                      )
                    )
                  }
                  updateSerialNumber={(id, itemId, body) =>
                    dispatch(updateSerialNumber(id, itemId, body))
                  }
                  updateOrderRowGoods={(body, orderId, rowId) =>
                    dispatch(updateOrderRowGoods(body, orderId, rowId))
                  }
                  deleteOrderRowGoods={(orderId, rowId) =>
                    dispatch(deleteOrderRowGoods(orderId, rowId))
                  }
                  store_url={order_shop.url}
                  order_rows={order_rows}
                />
              ))}
            </table>
          </div>
        </div>
      </Divs>
      {information_goods_add && (
        <OrderRowAdd
          orderId={order_id}
          postOrderRowGoods={(body, order_id) =>
            dispatch(postOrderRowGoods(body, order_id))
          }
          order_shop_id={order_shop.id}
          order_rows={order_rows}
        />
      )}
    </>
  );
}
